module.exports = __webpack_public_path__ + "static/img/osazie.4082240.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/osazie.jpeg
// module id = T/29
// module chunks = 0